module.exports = __webpack_public_path__ + "img/back.cf48811d.png";